import { render, staticRenderFns } from "./pageTwo.vue?vue&type=template&id=1e310b26&scoped=true&"
import script from "./pageTwo.vue?vue&type=script&lang=js&"
export * from "./pageTwo.vue?vue&type=script&lang=js&"
import style0 from "./pageTwo.vue?vue&type=style&index=0&id=1e310b26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e310b26",
  null
  
)

export default component.exports